import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BlogIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_506_3646)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.8861 13.7731L8.4308 8.89062L7.4873 6.18237L10.3501 6.35262L16.8046 11.2351C16.9707 11.3608 17.1105 11.5179 17.2159 11.6976C17.3214 11.8773 17.3904 12.076 17.419 12.2824C17.4476 12.4888 17.4353 12.6987 17.3828 12.9003C17.3302 13.1019 17.2385 13.2912 17.1128 13.4574L17.1068 13.4649C16.8532 13.8002 16.4767 14.0211 16.0603 14.0789C15.6438 14.1367 15.2214 14.0267 14.8861 13.7731Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.8096 4.53149V2.28149C11.8096 1.98313 11.691 1.69698 11.4801 1.486C11.2691 1.27502 10.9829 1.15649 10.6846 1.15649H1.68457C1.3862 1.15649 1.10005 1.27502 0.889075 1.486C0.678097 1.69698 0.55957 1.98313 0.55957 2.28149V13.5315C0.55957 13.8299 0.678097 14.116 0.889075 14.327C1.10005 14.538 1.3862 14.6565 1.68457 14.6565H6.93457L9.55957 16.9065V14.6565H10.6846C10.8935 14.6566 11.0984 14.5984 11.2761 14.4886C11.4539 14.3788 11.5976 14.2216 11.6911 14.0347",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.80957 3.40649H6.18457",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.49707 3.40649V6.78149",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.80957 9.59399H5.62207",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.80957 11.844H7.30957",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_506_3646",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
